var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inline-flex gap-1 rounded-lg bg-brand-gray-7 dark:bg-brand-gray-12 p-1",attrs:{"data-component":"CsSegmentedControls"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }